module.exports = require("@seddi/ui-viewport-core");